import { styled } from '@mui/material'

export const Main = styled('main')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  flexGrow: 1,
}))
